import { ChallengeYouTubeDescriptionModule } from '@chlngers/core/lib/src/types/challenge';
import { DescriptionVideoModuleFormType } from '@container/Challenge/NewChallengeForm/NewChallengeForm.types';

export const convertData2Form: (
  module: ChallengeYouTubeDescriptionModule,
) => DescriptionVideoModuleFormType = (module) => {
  return {
    type: module.type,
    youtubeId: module.youtubeId || '',
  };
};

export const convertForm2Data: (
  module: DescriptionVideoModuleFormType,
) => ChallengeYouTubeDescriptionModule = (module) => {
  if (!module) throw Error("this shouldn't be happened");
  return module;
};
